export default "__VITE_ASSET__BWLFaW6u__"